<template>
    <div id="container">
        <!-- homePage设置keepAlive为true缓存首页，其它页面不需要缓存 -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>
export default {
    name: 'PageView'
}
</script>
<style scoped>

</style>




// WEBPACK FOOTER //
// src/view/PageView.vue